import { Grid } from '@material-ui/core';
import Axios from 'axios';
import * as Cookie from 'js-cookie';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import error from '../../../../assets/images/error.svg';
import Eye from '../../../../assets/images/eye.svg';
import { BackButton } from '../../../../components/BackButton';
import { Button } from '../../../../components/Button';
import { Input } from '../../../../components/Input';
import { IAsyncData } from '../../../../models';
import { ROUTES } from '../../../../router/consts';
import { IApplicationState } from '../../../../store/models';
import { isError, makePath } from '../../../../utils';
import { Container } from '../../../Layout/components/Container';
import { handleLogin } from '../../store/actions';
import { ILoginFormResponse } from '../../store/models';

import './index.scss';

enum EFieldName {
    USERNAME = 'username',
    PASSWORD = 'password'
}

export type TLoginForm = Record<EFieldName, string>;

export const LoginForm: React.FC = () => {
    const [isPasswordVisible, togglePasswordVisibility] = React.useState<boolean>(false);
    const { register, handleSubmit } = useForm<TLoginForm>();
    const dispatch = useDispatch();
    const history = useHistory();
    const loginBranch = useSelector<IApplicationState, IAsyncData<ILoginFormResponse>>((state) => state.login);

    const handleSubmitForm = (form: TLoginForm) => {
        dispatch(handleLogin(form)).payload
            .then(({ data: { api_token, project } }) => {
                Cookie.set('api_token', api_token);
                Axios.defaults.headers.Authorization = `Bearer ${Cookie.get('api_token')}`;
                history.push(makePath(ROUTES.PROJECT, { slug: project.slug }));
            });
    };

    return (
        <Container>
            <Grid justify="center" container>
                <Grid xs={12} sm={12} md={6} item>
                    <div className="loginForm">
                        <BackButton />
                        <div>
                            <Input
                                placeholder="Username"
                                name={EFieldName.USERNAME}
                                register={register({ required: true })}
                                className="loginForm__input"
                            />
                        </div>
                        <div className="loginForm__formGroup">
                            <Input
                                placeholder="Password"
                                name={EFieldName.PASSWORD}
                                register={register({ required: true })}
                                className="loginForm__input"
                                type={`${isPasswordVisible ? 'text' : 'password'}`}
                            />
                            <img className="eye-icon" src={Eye} onClick={() => togglePasswordVisibility(!isPasswordVisible)} alt="" />
                        </div>
                        <div className="loginForm__submit">
                            <Button onClick={handleSubmit(handleSubmitForm)}>
                                Login
                </Button>
                        </div>
                        {
                            isError(loginBranch) && (
                                <div className="response-status">
                                    <img src={error} alt="" /> Error
                    </div>
                            )
                        }
                    </div>
                </Grid>
            </Grid>
        </Container>
    );
};
